"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const segment_1 = require("../../utils/development/segment");
const events_1 = require("../../utils/dom/events");
const links_1 = require("../../utils/dom/links");
/**
 * Proxy and useCallback and send an event each time it is call,
 * it also extract props automatically from the event and the event target
 *
 * @example: tracking click event
 *
 * The following code will dispatch an event each time the anchor get clicks
 *
 * ```tsx
 * export function Component() {
 *   const handleClick = useTrackLinkContext()
 *   /// analytics.track('click', { location: '...', href: '...', text: 'click here' })
 *
 *   return <a href="..." onClick={handleClick}>click here</a>
 * }
 * ```
 *
 * @example: tracking extra data
 *
 * To send more date to segment you can use [`dataset`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset) to do it
 *
 * ```tsx
 * export function Component() {
 *   const handleClick = useTrackLinkContext()
 *   /// analytics.track('click', { ..., ref: 'email' })
 *
 *   return <a href="..." data-ref="email" onClick={handleClick}>click here</a>
 * }
 * ```
 *
 * @example: tracking a custom event
 *
 * To send a custom event to segment you can defined on the `dataset-event` prop
 *
 * ```tsx
 * export function Component() {
 *   const handleClick = useTrackLinkContext()
 *   /// analytics.track('custom_event', { ... })
 *
 *   return <a data-event="custom_event"  href="..." onClick={handleClick}>click here</a>
 * }
 * ```
 */
function useTrackLinkContext(callback, deps = []) {
    return (0, react_1.useCallback)(((event, ...extra) => {
        const name = (0, events_1.getMouseEventName)(event);
        const data = (0, events_1.getMouseEventData)(event);
        if (callback) {
            const aggregated = callback(event, ...extra);
            if (aggregated && typeof aggregated == 'object') {
                Object.assign(data, aggregated);
            }
        }
        if (!(0, links_1.isLocalLink)(data.href) &&
            !(0, links_1.isBlankTarget)(data.target) &&
            !(0, events_1.isMeta)(event) &&
            !event.defaultPrevented) {
            event.preventDefault();
            (0, segment_1.track)(name, data, () => {
                window.location.href = data.href;
            });
        }
        else {
            (0, segment_1.track)(name, data);
        }
    }), deps);
}
exports.default = useTrackLinkContext;
